import { Component, OnInit, ViewEncapsulation, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ClipBoardService } from 'src/app/services/clipboard.service';
import { ServerService } from 'src/app/services/server.service';
import * as WebDataRocks from 'webdatarocks';
import { DatePipe } from '@angular/common';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-telecaller-wise-call-dashboard',
  templateUrl: './telecaller-wise-call-dashboard.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./telecaller-wise-call-dashboard.component.scss']
})
export class TelecallerWiseCallDashboardComponent implements OnInit, AfterViewInit {
  @ViewChild('pivotContainer', { static: false }) pivotContainer: ElementRef;
  @ViewChild('weekpivotContainer', { static: false }) weekpivotContainer: ElementRef;
  @ViewChild('leadstatusContainer', { static: false }) leadstatusContainer: ElementRef;

  authToken = localStorage.getItem("token");

  detailedTable: any;
  filterForm: FormGroup;
  weekDay: any;
  noFilter = true;
  weekRealJson: any = [];;
  isFilter: boolean = false;
  btnStatus: boolean = false;
  projectByUsers: any;
  demoWeekJSON: any;
  week: any;
  myDateRangePickerOptions = {
    dateFormat: 'dd-mm-yyyy'
  };
  // dateRange: any = { "beginDate": { "year": 2023, "month": 4, "day": 1 }, "endDate": { "year": 2023, "month": 4, "day": 30 } }
  dateRange: any = ""
  load = false;
  clients: any[] = []
  selectedClients: any[] = []

  projects: any[] = [];
  shouldRenderSecondElement = false;
  shouldRenderUserElement = false;
  shouldRenderProjectElement = false;
  selectedProjects: any[] = []
  realJson: any = [];
  demoJSON: any = [];

  reports: any;

  users: any[] = []
  selectedusers: any[] = []

  leadStatusList: any[] = [
  ]
  selectedLeadStatusList: any[] = []
  teleCallerDetails: any;
  leadStateWiseReport:any
  stateData:any;
  constructor(
    private serverService: ServerService,
    private clipBoardService: ClipBoardService,
    private _fb: FormBuilder,
    private datePipe: DatePipe
  ) {

  }

  ngOnInit() {

    this.setFilter()
    this.getClients()
    this.getProjects()
    this.getUsers()
    this.getLeadStatus()

    this.filterForm.get('dateRange').valueChanges.subscribe(res=>{
      if(res==null){
        //this.filterForm.reset()
        this.noFilter = true;
        this.isFilter = false;
        this.load = false
      }
    })

  }
  ngAfterViewInit() {
    // debugger
    // this.teleCallerReport()

  }
  teleCallerReport() {
    let body = {
      // "date_range": ["2018-10-10", "2023-08-16"]

    }
    if (this.filterForm.value['dateRange']) {
      // body["date_range"] = [this.filterForm.value['dateRange'].formatted.split(" - ")[0], this.filterForm.value['dateRange'].formatted.split(" - ")[1]];
      body["date_range"] = [this.filterForm.value.dateRange.beginDate.year + '-' + this.filterForm.value.dateRange.beginDate.month + '-' + this.filterForm.value.dateRange.beginDate.day, this.filterForm.value.dateRange.endDate.year + '-' + this.filterForm.value.dateRange.endDate.month + '-' + this.filterForm.value.dateRange.endDate.day]
    }

    if (this.filterForm.value['project']) {
      body['project_ids'] = this.filterForm.value['project']
    }
    if (this.filterForm.value['client']) {
      body['client_ids'] = this.filterForm.value['client']
    }
    if (this.filterForm.value['user']) {
      body['user_ids'] = this.filterForm.value['user']
    }
    if (this.filterForm.value['leadState']) {
      body['lead_states'] = this.filterForm.value['leadState']
    }

    // console.log(body)

    this.serverService.getTelecallerReport(body, this.authToken).subscribe((data) => {
      // console.log(data.week_day_call_report)
      this.reports = data.project_wise_call
      // console.log(this.reports)
       this.leadStateWiseReport = data.lead_state_wise_call;

 
      const transformedData: any[] = this.reports.map((item) => ({
        "Users": item.Name,
        "Project Name": item.project_name,
        "Total Call": item.total_calls,
        Connected: item.connected_calls,
        Talktime:item.talk_time==null?0:item.talk_time,
        "Total Verified": item.verified,
        Fresh: item.fresh,
        "V Under Review":item.v_under_review,
        // "Not Interested": item.v_not_interested,
        "Callback":item.callback,
        // "Follow Up":item.follow_up,
        "V Booking Done":item.v_booking_done,
        "V Follow Up":item.v_follow_up,
        "V Hold":item.v_hold,
        "V Interested":item.v_interested,
        "V Not Available":item.v_not_available,
        "V Not Interested":item.v_not_interested,
        "V Not Responding":item.v_not_responding,
        "V Sv Done":item.v_sv_done,
        "V Sv Drop":item.v_sv_drop

      }));
      // console.log(transformedData)
      this.reports = transformedData;
      // console.log(this.reports)
      this.realJson = this.reports;
      this.teleCallerDetails = data;
      // console.log(this.teleCallerDetails)
      this.week = data.week_day_call_report
      const transformedWeekData: any[] = this.week.map((item) => ({
        "Weekdays": item.Weekday,
        "Project Name": item.project_name,
        "Total Call": item.total_calls,
        Connected: item.connected_calls,
        Talktime:item.talk_time,
        "Total Verified": item.verified,
        Fresh: item.fresh,
        "V Under Review":item.v_under_review,
        // "Not Interested": item.v_not_interested,
        "Callback":item.callback,
        // "Follow Up":item.follow_up,
        "V Booking Done":item.v_booking_done,
        "V Follow Up":item.v_follow_up,
        "V Hold":item.v_hold,
        "V Interested":item.v_interested,
        "V Not Available":item.v_not_available,
        "V Not Interested":item.v_not_interested,
        "V Not Responding":item.v_not_responding,
        "V Sv Done":item.v_sv_done,
        "V Sv Drop":item.v_sv_drop

      }));
      const transformedLeadStateData: any[] = this.leadStateWiseReport.map((item) => ({
        // "Weekdays": item.Weekday,
        "Users": item.Name,
        "Lead State":item.lead_state,
        "Total Call": item.total_calls,
        // Connected: item.connected_calls,
        Talktime:item.talk_time,
        "Completed Calls":item.completed_calls,
 
        "Progress Call":item.in_progress_calls,
        "No Answer Call":item.no_answer_calls,
        "Ringing Calls":item.ringing_calls,
        "Busy Calls":item.busy_calls

      }));
      // console.log(transformedLeadStateData);
      this.week = transformedWeekData;
      this.stateData = transformedLeadStateData
      this.isFilter = true
      // console.log(this.week)
      //console.log(data)

      var pivot = new WebDataRocks({
        container: this.pivotContainer.nativeElement,
        // width:800,
        height: 400,
        // toolbar: true,
        report: {
          "formats": [
            {
                "name": "number",
                // "decimalPlaces": 2,
                "thousandsSeparator":","
                // "currencySymbol": "$"
            }
        ],
          dataSource: {
            data: this.reports
          },

          options: {
            grid: {
              type: "classic",
              showTotals: "on",
              // showGrandTotals: "off", 
            }
          },
          
        
          "slice": {
            "rows": [
              { "uniqueName": "Users" },
              { "uniqueName": "Project Name" },

            ],

            "measures": [
              {
                "uniqueName": "Total Call",
                "aggregation":"sum",
                // "caption":"Total Call",
                "format": "number",
              },
              {
              "uniqueName": "Connected",
              "aggregation":"sum",
              // "caption":"Connected",
              "format": "number",
            },
            {
              "uniqueName": "Talktime",
               "aggregation":"sum",
              // "caption":"Talktime",
              // "format": "number",
              // "format": "number",
              "format": "number"
             
            },
            
            {
              "uniqueName": "Fresh",
              "aggregation":"sum",
              // "caption":"Fresh"
              "format": "number",
            },
            {
              "uniqueName": "V Under Review",
              "aggregation":"sum",
              // "caption":"Fresh"
              "format": "number",
            },
            
            {
              "uniqueName": "Total Verified",
              "aggregation":"sum",
              // "caption":"Total Verified"
              "format": "number",
            },
           
            // {
            //   "uniqueName": "Not Interested",
            //   "aggregation":"sum",
            //   // "caption":"Not Interested"
            // },
            {
              "uniqueName": "Callback",
              "aggregation":"sum",
              "format": "number",
              // "caption":"Not Interested"
            },
            // {
            //   "uniqueName": "Follow Up",
            //   "aggregation":"sum",
            //   // "caption":"Not Interested"
            // },
            {
              "uniqueName": "V Booking Done",
              "aggregation":"sum",
              "format": "number",
              // "caption":"Not Interested"
            },
            {
              "uniqueName": "V Follow Up",
              "aggregation":"sum",
              "format": "number",
              // "caption":"Not Interested"
            },
            {
              "uniqueName": "V Hold",
              "aggregation":"sum",
              "format": "number",
              // "caption":"Not Interested"
            },
            {
              "uniqueName": "V Interested",
              "aggregation":"sum",
              "format": "number",
              // "caption":"Not Interested"
            },
            {
              "uniqueName": "V Not Available",
              "aggregation":"sum",
              "format": "number",
              // "caption":"Not Interested"
            },
            {
              "uniqueName": "V Not Interested",
              "aggregation":"sum",
              "format": "number",
              // "caption":"Not Interested"
            },
            {
              "uniqueName": "V Not Responding",
              "aggregation":"sum",
              "format": "number",
              // "caption":"Not Interested"
            },
            {
              "uniqueName": "V Sv Done",
              "aggregation":"sum",
              "format": "number",
              // "caption":"Not Interested"
            },
            {
              "uniqueName": "V Sv Drop",
              "aggregation":"sum",
              "format": "number",
              // "caption":"Not Interested"
            },
            
           
          

            ],
            

          },
          
         
          
        },
        customizeCell: (cell, data) => {
          if (data.isGrandTotalColumn || data.isGrandTotalRow) {
            if (data.label) {
              cell.text = data.label.replace('Total Sum of ', '');
            }
          }
        },
        
      });

      var leadStatusReport = new WebDataRocks({
        container: this.leadstatusContainer.nativeElement,
        // width:800,
        height: 400,
        // toolbar: true,
        report: {
          "formats": [
            {
                "name": "number",
                // "decimalPlaces": 2,
                "thousandsSeparator":","
                // "currencySymbol": "$"
            }
        ],
          dataSource: {
            data: transformedLeadStateData
          },

          options: {
            grid: {
              type: "classic",
              showTotals: "on",
              // showGrandTotals: "off", 
            }
          },
          
        
          "slice": {
            "rows": [
              { "uniqueName": "Users" },
              { "uniqueName": "Lead State" },
              
        

            ],

            "measures": [
              {
                "uniqueName": "Total Call",
                "aggregation":"sum",
                "caption":"Total Call"
              },
              
           

            {
              "uniqueName": "Talktime",
              "aggregation":"sum",
              "caption":"Talktime"
            },


            {
              "uniqueName": "Completed Calls",
              "aggregation":"sum",
              "caption":"Completed Calls"
            },
            {
              "uniqueName": "Progress Call",
              "aggregation":"sum",
              "caption":"Progress Call"
            },
            {
              "uniqueName": "No Answer Call",
              "aggregation":"sum",
              "caption":"No Answer Call"
            },
            {
              "uniqueName": "Ringing Calls",
              "aggregation":"sum",
              "caption":"Ringing Calls"
            },
            {
              "uniqueName": "Busy Calls",
              "aggregation":"sum",
              "caption":"Busy Calls"
            },
          

            ],


          }
          
         
          
        },
        customizeCell: (cell, data) => {
          if (data.isGrandTotalColumn || data.isGrandTotalRow) {
            if (data.label) {
              cell.text = data.label.replace('Total Sum of ', '');
            }
          }
        },
        
      });

      var pivot_week = new WebDataRocks({
        container: this.weekpivotContainer.nativeElement,
        height: 400,
        // toolbar: true,
        report: {
          "formats": [
            {
                // "name": "number",
                // "decimalPlaces": 2,
                "thousandsSeparator":","
                // "currencySymbol": "$"
            }
        ],
          dataSource: {
            data: this.week
          },
          options: {
            grid: {
              type: "classic",
              
            }
          },
          "slice": {
            "rows": [
              { "uniqueName": "Weekdays" },
              { "uniqueName": "Project Name" },

            ],

            "measures": [
              {
                "uniqueName": "Total Call",
                "aggregation":"sum",
                "caption":"Total Call"
              },
              {
              "uniqueName": "Connected",
              "aggregation":"sum",
              "caption":"Connected"
            },
            {
              "uniqueName": "Talktime",
              "aggregation":"sum",
              "caption":"Talktime"
            },
            {
              "uniqueName": "Fresh",
              "aggregation":"sum",
              // "caption":"Fresh"
            },
            {
              "uniqueName": "V Under Review",
              "aggregation":"sum",
              // "caption":"Fresh"
            },
            
            {
              "uniqueName": "Total Verified",
              "aggregation":"sum",
              // "caption":"Total Verified"
            },
           
            // {
            //   "uniqueName": "Not Interested",
            //   "aggregation":"sum",
            //   // "caption":"Not Interested"
            // },
            {
              "uniqueName": "Callback",
              "aggregation":"sum",
              // "caption":"Not Interested"
            },
            // {
            //   "uniqueName": "Follow Up",
            //   "aggregation":"sum",
            //   // "caption":"Not Interested"
            // },
            {
              "uniqueName": "V Booking Done",
              "aggregation":"sum",
              // "caption":"Not Interested"
            },
            {
              "uniqueName": "V Follow Up",
              "aggregation":"sum",
              // "caption":"Not Interested"
            },
            {
              "uniqueName": "V Hold",
              "aggregation":"sum",
              // "caption":"Not Interested"
            },
            {
              "uniqueName": "V Interested",
              "aggregation":"sum",
              // "caption":"Not Interested"
            },
            {
              "uniqueName": "V Not Available",
              "aggregation":"sum",
              // "caption":"Not Interested"
            },
            {
              "uniqueName": "V Not Interested",
              "aggregation":"sum",
              // "caption":"Not Interested"
            },
            {
              "uniqueName": "V Not Responding",
              "aggregation":"sum",
              // "caption":"Not Interested"
            },
            {
              "uniqueName": "V Sv Done",
              "aggregation":"sum",
              // "caption":"Not Interested"
            },
            {
              "uniqueName": "V Sv Drop",
              "aggregation":"sum",
              // "caption":"Not Interested"
            },
            
           
          

            ],


          }
        },
        customizeCell: (cell, data) => {
          if (data.isGrandTotalColumn || data.isGrandTotalRow) {
            if (data.label) {
              cell.text = data.label.replace('Total Sum of ', '');
            }
          }
        },
      });

      if (this.week == '') {
        this.shouldRenderSecondElement = true;
      }
      if (this.leadStateWiseReport == '') {
        this.shouldRenderUserElement = true;
      }
      if (this.reports == '') {
        this.shouldRenderProjectElement = true;
      }
      this.load = true
      // console.log(data)
    })
  }

  setFilter() {
    this.filterForm = this._fb.group({
      dateRange: ['', Validators.compose([Validators.required])],
      client: [''],
      project: [''],
      user: [''],
      leadState: [''],
    })

    // console.log(this.filterForm['client'])
  }

  filterSubmit() {

    this.isFilter = true;
    this.noFilter = false;
    if (this.filterForm.invalid) {
      return false
    }

    // console.log(this.filterForm.value)
    let d1 = [this.filterForm.value['dateRange'].formatted.split(" - ")[0], this.filterForm.value['dateRange'].formatted.split(" - ")[1]]
    this.teleCallerReport();

    // console.log(d1)
  }


  getClients() {
    this.serverService.clientsList(this.authToken).subscribe(data => {
      // console.log(data)
      this.clients = data.client
    }, err => {
      this.clipBoardService.checkServerError(err, this.authToken)
    }
    )
  }

  getProjects() {
    this.serverService.projectsList(this.authToken).subscribe(data => {
      this.projects = data
    }, err => {
      this.clipBoardService.checkServerError(err, this.authToken)
    }
    )
  }

  getUsers() {
    this.serverService.usersList(this.authToken).subscribe(data => {
      this.users = data.users
    }, err => {
      this.clipBoardService.checkServerError(err, this.authToken)
    }
    )
  }

  getLeadStatus() {
    this.leadStatusList = [
      { id: 'Fresh', name: 'Fresh' },
      { id: 'Cold', name: 'Cold' },
    ]
  }


  filterLead() {
  }

  clear() {
    this.filterForm.reset()
    this.noFilter = true;
    this.isFilter = false;
    this.load = false
    // this.dateRange = {}
    // this.clients = []
    // this.projects = []
    // this.users = []
    // this.leadStatusList = []
  }
  generateExcelFile() {
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.reports);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  
    // Define the file name for the Excel file
    const fileName = 'project_wise_telecaller_call_report.xlsx';
  
    // Save the Excel file
    XLSX.writeFile(wb, fileName);
  }
  generateExcelFileWeekDay() {
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.week);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  
    // Define the file name for the Excel file
    const fileName = 'weekdays_telecaller_call_report.xlsx';
  
    // Save the Excel file
    XLSX.writeFile(wb, fileName);
  }
  generateExcelFileStateReport() {
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.stateData);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  
    // Define the file name for the Excel file
    const fileName = 'user_state_telecaller_call_report.xlsx';
  
    // Save the Excel file
    XLSX.writeFile(wb, fileName);
  }
}

